import axios from 'axios'
import _ from 'lodash'
import { validateTime } from '@/utils/timeValidator'

// state
const state = {
	dataForServer: {},
	formData: {},
}

// getters
const getters = {
}

// mutations
const mutations = {
	// Mutator for value variables
	SET_VARIABLE(state, payload) {
		const { key, value } = payload;
		if (state.hasOwnProperty(key)) {
		state[key] = value;
		}
	},

	UPDATE_SELECTED_DATA(state, { key, value }) {
		// append/update dataForServer
		state.dataForServer[key] = value;

		// need to set formatData
		state.formData[key] = value;
	},


	RESET_FORM_FIELDS(state) {
		state.formData = {};
		state.dataForServer = {};
	},


}


// actions
const actions = {
	// Action for value variables
	setVariable({ commit }, payload) {
		commit('SET_VARIABLE', payload);
	},

	updateSelectedData({ commit }, key, value) {
		commit('UPDATE_SELECTED_DATA', key, value)
	},

	resetFormFields({ commit }) {
		commit('RESET_FORM_FIELDS')
	},

	// Create new record for logged in user
	createForLoggedUser({ commit, state, dispatch, getters, rootState, rootGetters}) {
		let header = {
			...rootState.auth.header,
			headers: { ...(rootState.auth.header.headers || {}), 'Content-Type': 'application/json' },
		};

		const saveData = rootState.requestVos.digitalFormData;
		const clientRequestId = saveData.client_request_id;
		const url = rootState.auth.l + 'v2/appointment/'+clientRequestId+'/actual';

		axios.post(url, saveData, header)
			.then(response => {

			}).catch((error) => {
				console.log(error)
			});
	},

	// Create new record for non-logged in user
	createForNonLoggedUser({ commit, state, dispatch, getters, rootState, rootGetters}) {
		const header = {
					headers: {
					}
				}
		const saveData = rootState.requestVos.digitalFormData;
		const clientRequestId = saveData.client_request_id;
		const url = rootState.auth.l + 'v2/appointment/'+clientRequestId+'/actual-guest';

		axios.post(url, saveData, header)
			.then(response => {

			}).catch((error) => {
				console.log(error)
			});
	},

}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}